import { useTranslation } from 'react-i18next'
import { createUseStyles } from 'react-jss'
import Card from "../../components/Card"
import FullScreenLoadingIndicator from '../../components/FullScreenLoadingIndicator'
import { useAppSelector } from '../../redux/hooks'
import InfoCard from '../../components/InfoCard'
import CustomerGroupFilesByMonth from '../../components/CustomerGroupFilesByMonth'
import CompanyGroupGeneralFiles from '../../components/CompanyGroupGeneralFiles'
import { useEffect } from 'react'
import useFileActions from '../../hooks/useFileActions'

const CompanyGroupFiles = () => {
    const styles = useStyles()
    const { t } = useTranslation('companyGroups');

    const companyGroup = useAppSelector(state => state.companyGroup.companyGroup)
    const loading = useAppSelector(state => state.companyGroup.loading)
    const filesLoading = useAppSelector(state => state.files.loading)
    const files = useAppSelector(state => state.files.files)

    const { getCompanyGroupFiles } = useFileActions()
    
    useEffect(() => {
        if (files.length === 0) {
            getCompanyGroupFiles()
        }
    }, [])

    return (
        <>
        <Card className={styles.card}>
            <h2>
                {t('companyGroupFilesTitleTemplate', {ns: 'files', companyGroupName: companyGroup?.name})}
            </h2>
        </Card>
        <div className={styles.infoCardContainer}>
            <InfoCard title={t('members', {ns: 'common'})} className={styles.infoCard}>
                <div className={styles.row}>
                    {companyGroup?.customers.map((customer, index) => {
                    return (
                        <div>{customer.customerName}</div>
                    )
                    })}
                </div>
            </InfoCard>
        </div>
        <Card className={styles.container}>
            <CompanyGroupGeneralFiles files={files} expectedIncludedEmployerCount={companyGroup?.customers.length ?? 0} />
            <CustomerGroupFilesByMonth files={files} expectedIncludedEmployerCount={companyGroup?.customers.length ?? 0} />
        </Card>
        <FullScreenLoadingIndicator visible={loading || filesLoading} />
        </>
    )
}

export default CompanyGroupFiles

const useStyles = createUseStyles({
    card: {
        marginBottom: 20
    },
    infoCard: {
        flex: 1
    },
    row: {
        flex: 1,
        marginBottom: 10,
    },
    container: {
        marginBottom: 40
    },
    infoCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        columnGap: 20
    }
})
